import * as React from 'react';
import CategoryNavigationItem from './CategoryNavigationItem';
import SimpleViewSlider from 'react-view-slider/simple';
import Accordion from '../../../../Accordion';
import { ICategoryTreeItem } from '../../../interfaces';
import Button from '../../../../../../react/common/components/form/Button';
import { translate } from 'PyzShopUi/scripts/utils/translate';
import useFindCategoryByKey from '../../../hooks/useFindCategoryByKey';

interface ICategoryNavigationProps {
    activeCategoryKey?: string;
    items: ICategoryTreeItem[];

    onBack(items: ICategoryTreeItem[], activeItem: ICategoryTreeItem): void;
    onSelect(item: ICategoryTreeItem): void;
}

const CategoryNavigation: React.FunctionComponent<ICategoryNavigationProps> = props => {
    const { items, activeCategoryKey, onBack, onSelect } = props;
    const activeItem = useFindCategoryByKey(items, activeCategoryKey);
    const ref = React.useRef(null);
    const [viewportStyle, setViewportStyle] = React.useState<object>({});
    const isSafariBrowser = () => navigator.userAgent.indexOf('Safari') > -1 && navigator.userAgent.indexOf('Chrome') <= -1

    React.useEffect(() => {
        //fix incorrect viewport in safari browser.
        if (isSafariBrowser()) {
            setViewportStyle({ width: ref.current.offsetWidth + 'px' });
        }
    }, []);

    const displayCurrentItem = React.useCallback(() => {
        if (!activeItem) {
            return <React.Fragment key={0}/>;
        }

        return <CategoryNavigationItem
            onSelect={onSelect}
            key={activeItem.id}
            item={activeItem}
        />;
    }, [activeItem]);

    const onClickBackButton = () => {
        onBack(items, activeItem);
    }

    const displayBackButton = React.useCallback(() => {
        if (!activeItem || !activeItem.parentKey) {
            return null;
        }

        return <Button
            icon={`back`}
            additionalClass={`button-leading-icon button-category-back`}
            onClick={() => onClickBackButton()}
            label={translate(`Back`, 'bike-db')}
        />;
    }, [activeItem]);

    return (
        <div ref={ref} className={`navigation-section`}>
            <Accordion
                label={translate('Categories', 'article-list')}
                hideHeaderContentOnCollapsed={true}
                defaultCollapsed={true}
                isScrollToCurrentOnCollapsed={true}
                skipTransition
            >
                {displayBackButton()}
                <SimpleViewSlider viewportStyle={viewportStyle}>
                    {displayCurrentItem()}
                </SimpleViewSlider>
            </Accordion>
        </div>
    );
};

export default CategoryNavigation;
